module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/sightseeing_3-6cc36b8b2ba1751d6c502c160f5cf469.jpg";